import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: '事業内容', href: '/#services' },
    { label: '会社概要', href: '/#about' },
    { label: '料金案内', href: '/#pricing' },
    { label: 'お問い合わせ', href: '/#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="/"
            className={`font-heading text-2xl md:text-3xl font-light tracking-[0.15em] whitespace-nowrap transition-colors duration-500 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            RSE
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium tracking-wider whitespace-nowrap transition-colors duration-300 hover:opacity-70 ${
                  scrolled ? 'text-foreground-700' : 'text-white/90'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-5">
            <a
              href="tel:050-8896-3509"
              className={`text-sm whitespace-nowrap transition-colors duration-300 ${
                scrolled ? 'text-foreground-600' : 'text-white/80'
              }`}
            >
              <i className="ri-phone-line mr-1.5"></i>
              050-8896-3509
            </a>
            <a
              href="/#contact"
              className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                scrolled
                  ? 'bg-foreground-900 text-background-50 hover:bg-foreground-800'
                  : 'bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30'
              }`}
            >
              お問い合わせ
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-500 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="メニューを開く"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50/98 backdrop-blur-md rounded-2xl mb-4 p-6 flex flex-col gap-4 shadow-lg">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-foreground-700 text-base font-medium py-2 border-b border-background-200 last:border-0"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:050-8896-3509"
              className="text-foreground-600 text-sm py-2"
            >
              <i className="ri-phone-line mr-2"></i>050-8896-3509
            </a>
            <a
              href="/#contact"
              className="bg-foreground-900 text-background-50 text-center py-3 rounded-full text-sm font-medium"
              onClick={() => setMobileOpen(false)}
            >
              お問い合わせ
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
